import { render, staticRenderFns } from "./JoinHeader.vue?vue&type=template&id=6351d492&scoped=true"
import script from "./JoinHeader.vue?vue&type=script&lang=ts"
export * from "./JoinHeader.vue?vue&type=script&lang=ts"
import style0 from "./JoinHeader.vue?vue&type=style&index=0&id=6351d492&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6351d492",
  null
  
)

export default component.exports